/* eslint-env node */
// Numeric membership rates and the two date gates. No React imports.
// src/data/pricing.js (the page) and api/chat.js (Clara) both import this
// module so a rate change cannot update one clock and leave the other behind.
//
// CommonJS on purpose. The Vercel Node runtime loads API routes with require().
// require() of an .mjs file throws ERR_REQUIRE_ESM and exits the process, which
// 500s every route that reaches this module (Approvals via pricing.js, Messages
// via agent-actions, and Clara). Do not rename this back to .mjs.
//
// The filename must stay membershipRates, not pricing. A sibling pricing.mjs
// is what webpack resolves ahead of pricing.js, which drops TRIAL_URL from the
// client bundle.
//
// Dates are local midnights, matching the page clock (not UTC date-only parse).

exports.MEMBERSHIP_30_CURRENT = 199;
exports.MEMBERSHIP_45_CURRENT = 299;
exports.MEMBERSHIP_60_CURRENT = 360;

exports.MEMBERSHIP_30_NEW = 229;
exports.MEMBERSHIP_45_NEW = 349;
exports.MEMBERSHIP_60_NEW = 419;

exports.PRICE_INCREASE_DATE = new Date(2026, 8, 1); // 2026-09-01
exports.MEMBERSHIP_MIGRATION_DATE = new Date(2027, 0, 1); // 2027-01-01

exports.membershipIncreaseIsLive = (now = new Date()) => now >= exports.PRICE_INCREASE_DATE;

exports.membershipRates = (now = new Date()) =>
  exports.membershipIncreaseIsLive(now)
    ? { min30: exports.MEMBERSHIP_30_NEW, min45: exports.MEMBERSHIP_45_NEW, min60: exports.MEMBERSHIP_60_NEW }
    : { min30: exports.MEMBERSHIP_30_CURRENT, min45: exports.MEMBERSHIP_45_CURRENT, min60: exports.MEMBERSHIP_60_CURRENT };
